import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TableComponent } from '../table/components/table/table.component';
import { TableColumnDirective } from '../table/directives/column.directive';
import { ClientPortalOverviewValuePipe } from '../../shared/pipes/client-portal-overview-table.pipe';

export interface OverviewTableRow {
  label: string | Date;
  value: number;
}

enum OverviewTableColumn {
  LABEL = 'label',
  VALUE = 'value',
}

@Component({
  selector: 'app-client-portal-overview-table',
  templateUrl: './client-portal-overview-table.component.html',
  styleUrls: ['./client-portal-overview-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableComponent, TableColumnDirective, RouterModule, ClientPortalOverviewValuePipe],
})
export class ClientPortalOverviewTableComponent implements OnChanges {
  @Input() title: string = '';
  @Input() titleNavUrl: string = '';
  @Input() subTitle: string = '';
  @Input() subTitleType: 'string' | 'date' = 'string';
  @Input() rows: OverviewTableRow[] | null = [];
  columns: any[] = [];
  total: number = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['subTitle'] || changes['subTitleType']) {
      this.setColumns(this.subTitle, this.subTitleType);
    }

    if (changes['rows']) {
      this.setTotal(this.rows);
    }
  }

  private setColumns(subTitle: string, subTitleType: string): void {
    this.columns = [
      {
        header: subTitle,
        field: OverviewTableColumn.LABEL,
        sortable: true,
        type: subTitleType,
      },
      {
        header: 'Count',
        field: OverviewTableColumn.VALUE,
        sortable: false,
      },
    ];
  }

  private setTotal(rows: OverviewTableRow[] | null): void {
    this.total = this.rows?.reduce((acc, row) => acc + row.value, 0) || 0;
  }
}
